module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./~/element-ui/~/core-js/library/modules/_add-to-unscopables.js
// module id = 1035
// module chunks = 0